import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import NarrativaCard from './NarrativaCard';
import preinformeStyles from './preinformeStyles';

/**
 * Sección narrativa de solo lectura (oportunidades, fortalezas o
 * recomendaciones): título + rejilla de `NarrativaCard`. No renderiza nada
 * (título ni contenedor) cuando `items` está vacío, para no dejar un título
 * huérfano cuando el payload no trae datos para esta sección.
 */
const SeccionNarrativa = ({ titulo, items, conSeveridad, numerada, columnas }) => {
    const classes = preinformeStyles();

    if (!items || items.length === 0) {
        return null;
    }

    return (
        <>
            <Typography variant="h6" component="h2" className={classes.sectionTitle}>
                {titulo}
            </Typography>
            <Grid container spacing={3}>
                {items.map((item) => (
                    <Grid item xs={12} md={columnas} lg={columnas} key={`${item.orden}-${item.titulo}`}>
                        <NarrativaCard
                            titulo={item.titulo}
                            cuerpo={item.cuerpo}
                            severidad={conSeveridad ? item.severidad : null}
                            numero={numerada && typeof item.orden === 'number' && Number.isFinite(item.orden) ? item.orden : null}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

SeccionNarrativa.propTypes = {
    titulo: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        orden: PropTypes.number,
        titulo: PropTypes.string,
        cuerpo: PropTypes.string,
        severidad: PropTypes.number,
    })),
    conSeveridad: PropTypes.bool,
    numerada: PropTypes.bool,
    columnas: PropTypes.number,
};

SeccionNarrativa.defaultProps = {
    items: [],
    conSeveridad: false,
    numerada: false,
    columnas: 6,
};

export default SeccionNarrativa;
